export const kWordsAvailabilities = ['available', 'notAvailable'] as const

export type KWordsAvailability = (typeof kWordsAvailabilities)[number]
